// src/components/charts/DonutChart.jsx
import React, { useMemo, useState } from "react";
import { Colors } from "../../constants/Colors";

const DEFAULT_SEGMENTS = [
  { key: "confirmed", label: "Active",    color: Colors.SECONDARY_BLUE },
  { key: "completed", label: "Completed", color: Colors.SUCCESS },
  { key: "pending",   label: "Pending",   color: Colors.WARNING },
  { key: "cancelled", label: "Cancelled", color: Colors.RED },
];

export default function DonutChart({ dist, size = 200, thickness = 24 }) {
  const [active, setActive] = useState(null);

  const segments = useMemo(() => {
    const total = dist.total || 0;
    let offset = 0;
    return DEFAULT_SEGMENTS.map((s) => {
      const value = dist[s.key] || 0;
      const pct = total ? (value / total) * 100 : 0;
      const seg = { ...s, value, pct, offset };
      offset += pct;
      return seg;
    });
  }, [dist]);

  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  const total = dist.total || 0;

  return (
    <div className="donut-wrap" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        role="img"
        aria-label={`Total ${total} rentals`}
      >
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={Colors.LIGHT_GRAY}
            strokeWidth={thickness}
          />
          {segments.map((s) => {
            const dash = (s.pct / 100) * c;
            const isActive = active === s.key;
            return (
              <circle
                key={s.key}
                cx={size / 2}
                cy={size / 2}
                r={r}
                fill="none"
                stroke={s.color}
                strokeWidth={isActive ? thickness + 6 : thickness}
                strokeDasharray={`${dash} ${c - dash}`}
                strokeDashoffset={-(s.offset / 100) * c}
                strokeLinecap="butt"
                style={{ transition: "stroke-width .15s ease", cursor: "pointer" }}
                onMouseEnter={() => setActive(s.key)}
                onMouseLeave={() => setActive(null)}
              >
                <title>{`${s.label}: ${s.value} (${s.pct.toFixed(1)}%)`}</title>
              </circle>
            );
          })}
        </g>
      </svg>
      <div className="donut-center" aria-hidden="true">
        {active ? (
          <>
            <span className="donut-center-value">
              {segments.find((s) => s.key === active).value}
            </span>
            <span className="donut-center-label">
              {segments.find((s) => s.key === active).label}
            </span>
          </>
        ) : (
          <>
            <span className="donut-center-value">{total}</span>
            <span className="donut-center-label">Total</span>
          </>
        )}
      </div>
    </div>
  );
}